import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04ee8f22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options" }
const _hoisted_2 = { class: "info" }

import { ref, computed, reactive } from 'vue';
import { useStore } from 'vuex';
import { get, has } from 'lodash';

import type { IOptions } from '@/models/engine/EngineBase';

import LayerLegend from '@/components/LayerLegend.vue';
import ImageLegend from '@/components/ImageLegend.vue';
import { getLegendData } from '@/store/utils/legend';
import * as Visualization from '@/carto-node/models/visualization';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapDetail',
  props: ['map', 'index'],
  emits: ['close'],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const store = useStore();



let visible = ref(false);

let layerOptions = reactive<IOptions>({
  alpha: 1,
  brightness: 1,
  contrast: 1,
  hue: 0,
  saturation: 1,
  gamma: 1,
});

const isDatahubLayer = computed(() => props.map && has(props.map, "layerServiceInfo"))

const legendData = computed(() => {
  return getLegendData(props.map);
});

const author = computed(() => {
  if (isDatahubLayer.value) {
    return props.map?.owner;
  } else {
    return props.map?.permission?.owner?.username;
  }
})

const mapTileUrl = computed(() => {
  if (isDatahubLayer.value) {
    return props.map?.layerServiceInfo?.url;
  } else {
    if (props.map?.permission?.owner?.base_url) {
      const tileUrl = Visualization.getMapTileUrl(props.map);
      return tileUrl;
    } else {
      if (props.map?.mapType == 'WMS') {
        return props.map?.wms?.url?.onlineResource;
      } else {
        return props.map?.url || props.map?.wmts?.url?.slippy?.replaceAll(/\{s\}/g, '1');
      }
    }
  }
})

const handleClick = () => {
  emit('close');
};

const handleLayerOptionsChange = (key: string, val: number) => {
  store.state.engineStore.engine.updateLayer(props.index, key, val);
};

const toggleColorPicker = () => {
  visible.value = !visible.value;
};

const recoverLayerOptions = () => {
  store.state.engineStore.engine.updateLayer(
    props.index,
    'alpha',
    layerOptions.alpha,
  );
  store.state.engineStore.engine.updateLayer(
    props.index,
    'brightness',
    layerOptions.brightness,
  );
  store.state.engineStore.engine.updateLayer(
    props.index,
    'contrast',
    layerOptions.contrast,
  );
  store.state.engineStore.engine.updateLayer(
    props.index,
    'gamma',
    layerOptions.gamma,
  );
  store.state.engineStore.engine.updateLayer(
    props.index,
    'hue',
    layerOptions.hue,
  );
  store.state.engineStore.engine.updateLayer(
    props.index,
    'saturation',
    layerOptions.saturation,
  );
};

const components = {
  LayerLegend,
  ImageLegend,
};

__expose({
  recoverLayerOptions,
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("header", null, [
      _createVNode(_component_el_row, {
        justify: "space-between",
        class: "title"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 22,
            class: "break-all-work"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.map.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { onClick: handleClick }, {
                default: _withCtx(() => [
                  _createVNode(_component_Close)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_row, {
            class: "option-item",
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('MapDetail.opacity')), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_el_slider, {
                  modelValue: _unref(layerOptions).alpha,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(layerOptions).alpha) = $event)),
                  max: 1,
                  step: 0.01,
                  onChange: _cache[1] || (_cache[1] = (val) => {
              handleLayerOptionsChange('alpha', val)
            })
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_el_row, {
            class: "option-item",
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('MapDetail.brightness')), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_el_slider, {
                  modelValue: _unref(layerOptions).brightness,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(layerOptions).brightness) = $event)),
                  max: 3,
                  step: 0.03,
                  onChange: _cache[3] || (_cache[3] = (val) => handleLayerOptionsChange('brightness', val))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, _unref(visible)]
          ]),
          _withDirectives(_createVNode(_component_el_row, {
            class: "option-item",
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('MapDetail.hue')), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_el_slider, {
                  modelValue: _unref(layerOptions).hue,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(layerOptions).hue) = $event)),
                  max: 3,
                  step: 0.03,
                  onChange: _cache[5] || (_cache[5] = (val) => handleLayerOptionsChange( 'hue', val))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, _unref(visible)]
          ]),
          _withDirectives(_createVNode(_component_el_row, {
            class: "option-item",
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('MapDetail.saturation')), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_el_slider, {
                  modelValue: _unref(layerOptions).saturation,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(layerOptions).saturation) = $event)),
                  max: 3,
                  step: 0.03,
                  onChange: _cache[7] || (_cache[7] = (val) => handleLayerOptionsChange('saturation', val))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, _unref(visible)]
          ]),
          _withDirectives(_createVNode(_component_el_row, {
            class: "option-item",
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('MapDetail.shade')), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_el_slider, {
                  modelValue: _unref(layerOptions).gamma,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(layerOptions).gamma) = $event)),
                  max: 3,
                  step: 0.03,
                  onChange: _cache[9] || (_cache[9] = (val) => handleLayerOptionsChange('gamma', val,))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, _unref(visible)]
          ]),
          _withDirectives(_createVNode(_component_el_row, {
            class: "option-item",
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('MapDetail.contrast')), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_el_slider, {
                  modelValue: _unref(layerOptions).contrast,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(layerOptions).contrast) = $event)),
                  max: 3,
                  step: 0.03,
                  onChange: _cache[11] || (_cache[11] = (val) => handleLayerOptionsChange('contrast', val ))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, _unref(visible)]
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, { onClick: toggleColorPicker }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('MapDetail.more')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_el_tabs, { stretch: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('legend')
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(components[legendData.value.type]), {
                url: legendData.value.url,
                "show-title": false
              }, null, 8, ["url"]))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('MapDetail.metadata.title')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('MapDetail.metadata.name')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 18,
                      title: props.map.name
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.map.name), 1)
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('MapDetail.metadata.author')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 18,
                      title: author.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(author.value), 1)
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('MapDetail.metadata.tileurl')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 18,
                      title: mapTileUrl.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(mapTileUrl.value), 1)
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('MapDetail.metadata.description')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 18,
                      title: props.map?.description
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.map?.description), 1)
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, null, {
                          default: _withCtx(() => [
                            _createTextVNode("minX")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(get)(props, 'map.bounds[0][1]')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, null, {
                          default: _withCtx(() => [
                            _createTextVNode("maxX")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(get)(props, 'map.bounds[1][1]')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, null, {
                          default: _withCtx(() => [
                            _createTextVNode("minY")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(get)(props, 'map.bounds[0][0]')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, null, {
                          default: _withCtx(() => [
                            _createTextVNode("maxY")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(get)(props, 'map.bounds[1][0]')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})